import React from "react";
import PropTypes from "prop-types";
import CartIcon from "../SVGComponents/CartIcon";
import ItemCountBadge from "../ItemCountBadge";

const CheckoutButton = ({ orderCheckout, itemCount }) => (
  <button
    data-quid="checkout-button"
    className="sub-navigation__item sub-navigation__item--checkout"
    onClick={orderCheckout}
  >
    <CartIcon />
    checkout
    {itemCount > 0 && <ItemCountBadge itemCount={itemCount} />}
  </button>
);

CheckoutButton.propTypes = {
  orderCheckout: PropTypes.func.isRequired,
  itemCount: PropTypes.string
};

CheckoutButton.defaultProps = {
  itemCount: "0"
};

export default CheckoutButton;
